<template>
  <v-data-table
    :headers="headers"
    :items="providerAssignments"
    item-key="assignmentId"
    :key="providerAssignments.length"
    hide-default-footer
    :items-per-page="-1"
    dense
    ><template v-slot:[`top`]="{}">
      <v-subheader>Provider Assignments</v-subheader></template
    >
    <template v-slot:[`item.actions`]="{ item }">
      <provider-assignment-form
        v-if="!viewOnly && seit"
        :assignment="item"
        :servicePlanId="servicePlanId"
      ></provider-assignment-form>
    </template>
  </v-data-table>
</template>

<script>
import ProviderAssignmentForm from "./provider-assignment-form";

export default {
  components: { ProviderAssignmentForm },
  props: ["servicePlanId", "viewOnly"],
  data() {
    return {
      dialog: false,
      headers: [
        { text: "Provider", value: "providerName" },
        { text: "Mandate", value: "mandate" },
        { text: "Approval Start Date", value: "formattedApprovalStartDate" },
        { text: "Appoval End Date", value: "formattedApprovalEndDate" },
        { text: "Start Date", value: "formattedStartDate" },
        { text: "End Date", value: "formattedEndDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    plan() {
      return this.$store.state.plansModule.plans.find((item) =>
        item.servicePlans.find(
          (item) => item.servicePlanId == this.servicePlanId
        )
      );
    },
    servicePlan() {
      return this.plan.servicePlans.find(
        (item) => item.servicePlanId == this.servicePlanId
      );
    },
    providerAssignments() {
      return this.servicePlan.assignments ?? [];
    },
    seit() {
      return ["SEIT", "PEND"].includes(this.servicePlan.program);
    },
  },
};
</script>
